import { genUploader } from "uploadthing/client"

import {
  buildCapturedAtFromFile,
  serializeUploadReference,
} from "@/features/public/report/upload-reference"
import type { OrchardObservationPhotoInput } from "@/lib/api/client"

interface UploadthingResult {
  fileHash?: string | null
  key?: string | null
  name?: string | null
  size?: number | null
  type?: string | null
  ufsUrl?: string | null
  url?: string | null
}

export interface UploadOrchardObservationPhotosInput {
  onStatusChange?: (message: string) => void
  photos: File[]
}

let uploaderPromise: Promise<ReturnType<typeof genUploader>> | null = null

async function getUploader() {
  if (!uploaderPromise) {
    uploaderPromise = Promise.resolve(
      genUploader({
        url: `${window.location.origin}/api/uploadthing`,
      })
    )
  }

  return uploaderPromise
}

export async function uploadOrchardObservationPhotos({
  onStatusChange,
  photos,
}: UploadOrchardObservationPhotosInput): Promise<OrchardObservationPhotoInput[]> {
  if (!photos.length) {
    return []
  }

  const uploader = await getUploader()
  const photoResults = (await uploader.uploadFiles("orchardObservationPhoto", {
    files: photos,
    onUploadProgress: ({ totalProgress }) => {
      onStatusChange?.(`Uploading orchard photos (${Math.max(totalProgress, 1)}%)...`)
    },
  })) as UploadthingResult[]

  const uploadedPhotos = photoResults.map((result, index) =>
    serializeUploadReference(result, {
      capturedAt: buildCapturedAtFromFile(photos[index]),
      uploadMetadata: {
        source: "public-orchard-observation",
        slot: `photo-${index + 1}`,
      },
    })
  )

  onStatusChange?.("Photos uploaded. Saving orchard observation...")

  return uploadedPhotos
}
